// extracted by mini-css-extract-plugin
export default {"madeWithMarvel":"_1Hs2Yw1NCZNXl3ndwXn_1Q"};